/**
 * settingsNav — a tiny navigation channel (same pattern as tilemap/store/
 * tilemapNav.ts) that lets the "Settings" link in the static Blade header
 * (resources/views/home.blade.php — outside the React root entirely) open
 * the Settings view inside the React app without any prop-drilling or a
 * real router. main.tsx wires a plain DOM click listener on that link to
 * call `settingsNav.getState().show()`; EditorShell subscribes to `open`
 * and swaps in SettingsView.
 */

import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';

interface SettingsNavState {
    open: boolean;
    show: () => void;
    hide: () => void;
}

export const settingsNav = createStore<SettingsNavState>((set) => ({
    open: false,
    show: () => set({ open: true }),
    hide: () => set({ open: false }),
}));

export function useSettingsNav<T>(selector: (s: SettingsNavState) => T): T {
    return useStore(settingsNav, selector);
}
